import React from 'react';
import { useSelector } from 'react-redux';

import CurrencyColumn from '../../../components/columns/currency-column';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const RateColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret) {
    return '';
  }

  const { labelCost } = ret || {};
  if (!labelCost) {
    return '';
  }

  const { value, code } = labelCost;
  return <CurrencyColumn currencyCode={code} value={value} />;
};

export const Rate = {
  getMessageDescriptor: () => messages.rate,
  id: 'rate',

  render: ({ fulfillmentId }) => {
    return <RateColumn fulfillmentId={fulfillmentId} />;
  },
};
